import { isEmpty } from 'lodash';
const DEFAULT = {};

export function selectUserResult(state) {
  const userId = state.auth.currentUserId;
  if (userId) {
    const results = Object.values(state.entities.results.byId);
    return results.find(result => result.user === userId) || DEFAULT;
  } else {
    return DEFAULT;
  }
}

export function resultHasError(state) {
  const currentUserResult = selectUserResult(state);
  const { endpointErrors } = state;
  return (
    currentUserResult.status === 'error' ||
    currentUserResult.status === 'unreachable' ||
    !isEmpty(endpointErrors.CREATE_RESULT)
  );
}

export function selectResult(state, resultUUID) {
  return state.entities.results.byId[resultUUID];
}

export function areResultsOwnedByUser(state) {
  const result = selectResult(state, state.currentResult) || {};
  const userId = state.auth.currentUserId;

  return result.user === userId;
}



// WEBPACK FOOTER //
// ./src/selectors/resultSelectors.js